import React from "react";
import "./style/Footer.css";
import scanner from "../assets/Image/scanner.png";
import qr from "../assets/Image/newscanner.webp";
import playstore from "../assets/Image/playstorebutton.png";
import googlepay from "../assets/Image/googlepay.png";
import sideImage from "../assets/Image/sideImage.png";
import GrievancePolicy from "../Pages/GrievancePolicy/GrievancePolicy";

const Footer = () => {
  return (
    <div style={{ overflowX: "hidden" }} className="footer-container-footer">
      <footer className="footer-text-center footer-text-lg-start">
        <div className="footer-container">
          <div className="footer-row">
            {/* Column 1: Header */}
            <div className="footer-col-12 footer-col-lg-12 footer-mb-4 footer-text-title-footer">
              <span
                style={{ marginTop: "30px", color: "white" }}
                className="footer-main-text-footer footer-main-text-mob-footer"
              >
                <span
                  className="footer-main-text-footer footer-main-text-mob-footer"
                  style={{ color: "#FF5613" }}
                >
                  HAVE A QUESTION?
                </span>
                <br />
                WE ANSWER YOU !
              </span>
            </div>

            <div className="footer-cards-container">
              <div className="footer-card1">
                <div className="footer-qr-contaier">
                  {/* <img src={scanner} alt="QR Code" className="footer-qr-code" /> */}
                  <img src={qr} alt="QR Code" className="shop-qr-code" />
                  <div className="footer-store-buttons">
                    {/* <img src={playstore} alt="Play Store" className="footer-store-img" /> */}
                    <a href="/Comingsoon">
                      <img
                        src={playstore}
                        alt="Play Store"
                        className="footer-store-img"
                      />
                    </a>

                    <a
                      href="https://play.google.com/store/apps/details?id=com.ntarbiz.business&pcampaignid=web_share"
                      target="_blank"
                    >
                      {/* <img src={googlepay} alt="App Store" className="footer-store-img" /> */}
                      <img
                        src={googlepay}
                        alt="App Store"
                        className="footer-store-img"
                      />
                    </a>
                  </div>
                </div>
              </div>

              <div className="footer-cards-container-sub">
                <div className="footer-category">
                  <p className="footer-header-text">INSIDE</p>
                  <div className="footer-subcategories">
                    <div className="footer-subcategory-container">
                      <a className="anchor" href="/Ntarpay">
                        <p className="footer-subcategory">NTAR Pay</p>
                      </a>
                      {/* <a
                        style={{ textDecoration: "none" }}
                        href="/Comingsoon"
                        className="footer-pots-comingsoon-button"
                      >
                        <p className="footer-subcategory">
                          NTAR Book {"\n"}
                          <button className="footer-coming-soon">
                            Coming soon
                          </button>
                        </p>
                      </a> */}
                      {/* <a
                        style={{ textDecoration: "none" }}
                        href="/Comingsoon"
                        className="footer-pots-comingsoon-button"
                      >
                        <p className="footer-subcategory">
                          NTAR Choice{"\n"}
                          <button className="footer-coming-soon">
                            Coming soon
                          </button>
                        </p>
                      </a> */}
                    </div>
                  </div>
                </div>

                {/* <div className="footer-category">
                  <p className="footer-header-text">EXPLORE</p>
                  <div className="footer-subcategories">
                    <a
                      style={{ textDecoration: "none" }}
                      href="/Comingsoon"
                      className="footer-subcategory-container"
                    >
                      <p className="footer-subcategory">
                        NTAR POS {"\n"}
                        <button className="footer-coming-soon">
                          Coming soon
                        </button>
                      </p>
                      <p className="footer-subcategory">
                        NTAR Next
                        {"\n"}
                        <button className="footer-coming-soon">
                          Coming soon
                        </button>
                      </p>
                      <p className="footer-subcategory">
                        NTAR Link
                        {"\n"}
                        <button className="footer-coming-soon">
                          Coming soon
                        </button>
                      </p>
                    </a>
                  </div>
                </div> */}

                <div className="footer-category">
                  <p className="footer-header-text">COMPANY</p>
                  <div className="footer-subcategories">
                    <div className="footer-subcategory-container">
                      <div className="footer-pots-comingsoon-button">
                        <p className="footer-subcategory">
                          <a
                            className="anchor"
                            href="/AboutUs"
                            style={{ color: "white" }}
                          >
                            Why NTAR
                          </a>
                          {"\n"}
                          {/* <button className="footer-coming-soon">We are Hiring</button> */}
                        </p>
                      </div>
                      <div className="footer-pots-comingsoon-button">
                        <p className="footer-subcategory">
                          <a
                            className="anchor"
                            href="/AboutUs"
                            style={{ color: "white" }}
                          >
                            About Us{" "}
                          </a>
                          {"\n"}
                          {/* <button className="footer-coming-soon">We are Hiring</button> */}
                        </p>
                      </div>
                      <a
                        style={{ textDecoration: "none" }}
                        href="/Comingsoon"
                        className="footer-pots-comingsoon-button"
                      >
                        <p className="footer-subcategory">
                          Careers
                          {"\n"}
                          <button className="footer-coming-soon">
                            coming soon
                          </button>
                        </p>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="footer-cards-container-sub footer-web-subcard">
                <div className="footer-category-2">
                  <p
                    style={{ textWrap: "nowrap", color: "#c2c2c2" }}
                    className="footer-header-text"
                  >
                    GET IN TOUCH
                  </p>
                  <div className="footer-subcategories">
                    <div className="footer-subcategory-containe2">
                      <a href="/ContactUs" className="footer-subcategory">
                        Contact Us
                      </a>
                      <p className="footer-ptag"></p>
                      <br></br>
                      <br></br>
                      <a href="/Complaint" className="footer-subcategory">
                        Complaint
                      </a>
                      <br></br>
                      <br></br>
                      <a
                        href="/FAQ"
                        style={{ textDecoration: "none" }}
                        className="footer-subcategory"
                      >
                        FAQ
                      </a>
                    </div>
                  </div>
                </div>
                {/* <div className="footer-category-3">
                  <p className="footer-header-text">IN SIGHTS</p>
                  <div className="footer-subcategories">
                    <div className="footer-subcategory-container">
                      <a
                        style={{ textDecoration: "none" }}
                        href="/Comingsoon"
                        className="footer-pots-comingsoon-button"
                      >
                        <p className="footer-subcategory">
                          Guide
                          <button className="footer-coming-soon">
                            Coming soon
                          </button>
                        </p>
                      </a>
                    
                      <a
                        style={{ textDecoration: "none" }}
                        href="/Comingsoon"
                        className="footer-pots-comingsoon-button"
                      >
                        <p className="footer-subcategory">
                          Community
                          <button className="footer-coming-soon">
                            Coming soon
                          </button>
                        </p>
                      </a>
                    </div>
                  </div>
                </div> */}
                <div className="footer-category-4">
                  <p className="footer-header-text">LEGAL</p>
                  <br />
                  <div className="footer-subcategories">
                    <div className="footer-subcategory-container">
                      <a
                        href="/Termsandconditions"
                        className="footer-subcategory"
                      >
                        Terms & Conditions
                      </a>
                      <br></br>
                      <br></br>
                      <a href="/Privacypolicy" className="footer-subcategory">
                        Privacy Policy
                      </a>
                      <br></br>
                      <br></br>
                      <a href="/RefundPolicy" className="footer-subcategory">
                        Refund Policy
                      </a>
                      <br></br>
                      <br></br>
                      <a href="/Cookiepolicy" className="footer-subcategory">
                        Cookie Policy
                      </a>
                      <br></br>
                      <br></br>
                      <a href="/GrievancePolicy" className="footer-subcategory">
                        Grievance Policy
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Column 3: Get in Touch */}
            <div className="footer-cards-container">
              <div
                id="footeraddP"
                className="footer-col-lg-6 footer-col-md-6 footer-address-sub-s footeradd"
              >
                <div className="footer-address-container">
                  <svg
                    width="60"
                    height="30"
                    viewBox="0 0 24 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.9998 13.2998C12.5602 13.2998 13.108 13.1336 13.574 12.8223C14.0399 12.511 14.403 12.0685 14.6175 11.5507C14.8319 11.033 14.8881 10.4633 14.7787 9.91371C14.6694 9.3641 14.3996 8.85925 14.0033 8.463C13.6071 8.06675 13.1022 7.7969 12.5526 7.68757C12.003 7.57825 11.4333 7.63436 10.9156 7.84881C10.3978 8.06325 9.95534 8.42641 9.64401 8.89235C9.33268 9.35829 9.1665 9.90609 9.1665 10.4665C9.1665 11.2179 9.46502 11.9386 9.99637 12.4699C10.5277 13.0013 11.2484 13.2998 11.9998 13.2998ZM10.994 23.089C11.1257 23.2217 11.2824 23.3271 11.455 23.3991C11.6277 23.471 11.8128 23.508 11.9998 23.508C12.1869 23.508 12.372 23.471 12.5447 23.3991C12.7173 23.3271 12.874 23.2217 13.0057 23.089L18.7998 17.2806C20.1456 15.9356 21.0622 14.2216 21.4338 12.3555C21.8054 10.4895 21.6152 8.55511 20.8873 6.79714C20.1594 5.03918 18.9265 3.53657 17.3445 2.47938C15.7625 1.42219 13.9025 0.85791 11.9998 0.85791C10.0971 0.85791 8.23716 1.42219 6.65519 2.47938C5.07322 3.53657 3.84031 5.03918 3.11241 6.79714C2.3845 8.55511 2.1943 10.4895 2.56587 12.3555C2.93743 14.2216 3.85407 15.9356 5.19984 17.2806L10.994 23.089ZM5.24234 9.8148C5.33913 8.80474 5.66028 7.82905 6.18233 6.95896C6.70438 6.08887 7.41416 5.34636 8.25984 4.78563C9.37079 4.05619 10.6708 3.66754 11.9998 3.66754C13.3289 3.66754 14.6289 4.05619 15.7398 4.78563C16.5799 5.34444 17.2856 6.08245 17.8064 6.94659C18.3271 7.81074 18.6499 8.77954 18.7515 9.78333C18.8531 10.7871 18.731 11.8009 18.394 12.7519C18.0569 13.7029 17.5134 14.5673 16.8023 15.2831L11.9998 20.0856L7.19734 15.2831C6.48549 14.5743 5.94065 13.7156 5.60246 12.7697C5.26427 11.8237 5.14125 10.8143 5.24234 9.8148ZM21.9165 26.3331H2.08317C1.70745 26.3331 1.34711 26.4824 1.08144 26.7481C0.81576 27.0137 0.666504 27.3741 0.666504 27.7498C0.666504 28.1255 0.81576 28.4859 1.08144 28.7515C1.34711 29.0172 1.70745 29.1665 2.08317 29.1665H21.9165C22.2922 29.1665 22.6526 29.0172 22.9182 28.7515C23.1839 28.4859 23.3332 28.1255 23.3332 27.7498C23.3332 27.3741 23.1839 27.0137 22.9182 26.7481C22.6526 26.4824 22.2922 26.3331 21.9165 26.3331Z"
                      fill="white"
                    />
                  </svg>
                  <p
                    id="address"
                    style={{
                      fontSize: "17px",
                      marginTop: "2px",
                      textAlign: "left",
                      fontFamily: "Poppins",
                    }}
                  >
                    H.No. 5-5-165/2/TF, Plot no. 4, 3rd Floor, Vanasthali Hills,
                    Vanastalipuram, Hayathnagar, K.V.Rangareddy, TG 500070 IN
                  </p>
                </div>
                <div className="footer-address-container">
                  <svg
                    className="footer-mail-svg"
                    width="30"
                    height="24"
                    viewBox="0 0 30 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M26.3335 0.666504H3.66683C2.1085 0.666504 0.847663 1.9415 0.847663 3.49984L0.833496 20.4998C0.833496 22.0582 2.1085 23.3332 3.66683 23.3332H26.3335C27.8918 23.3332 29.1668 22.0582 29.1668 20.4998V3.49984C29.1668 1.9415 27.8918 0.666504 26.3335 0.666504ZM24.9168 20.4998H5.0835C4.30433 20.4998 3.66683 19.8623 3.66683 19.0832V6.33317L13.4985 12.4815C14.4193 13.0623 15.581 13.0623 16.5018 12.4815L26.3335 6.33317V19.0832C26.3335 19.8623 25.696 20.4998 24.9168 20.4998ZM15.0002 10.5832L3.66683 3.49984H26.3335L15.0002 10.5832Z"
                      fill="white"
                    />
                  </svg>
                  <p
                    style={{
                      fontSize: "18px",
                      marginTop: "2px",
                      fontFamily: "Poppins",
                    }}
                  >
                    hello@ntarbizz.com
                  </p>
                </div>
              </div>

              <div className="footer-cards-container-sub footer-mob-subcard">
                <div className="footer-category-2">
                  <p
                    style={{ textWrap: "nowrap" }}
                    className="footer-header-text"
                  >
                    GET IN TOUCH
                  </p>
                  <div className="footer-subcategories">
                    <div className="footer-subcategory-container-con">
                      <a
                        id="leftcontact"
                        href="/ContactUs"
                        className="footer-subcategory"
                      >
                        Contact Us
                      </a>
                      <p className="footer-ptag"></p>
                      <a
                        id="leftcontact"
                        href="/Complaint"
                        className="footer-subcategory"
                      >
                        Complaint
                      </a>
                      <a href="/FAQ" className="anchor">
                        <p className="footer-subcategory">FAQ</p>
                      </a>
                    </div>
                  </div>
                </div>
                {/* <div className="footer-category-3">
                  <p className="footer-header-text">IN SIGHTS</p>
                  <div className="footer-subcategories">
                    <div className="footer-subcategory-container">
                      <a
                        style={{ textDecoration: "none" }}
                        href="/Comingsoon"
                        className="footer-pots-comingsoon-button"
                      >
                        <p className="footer-subcategory">
                          Guide
                          {"\n"}
                          <button className="footer-coming-soon">
                            Coming soon
                          </button>
                        </p>
                      </a>

                   
                      <a
                        style={{ textDecoration: "none" }}
                        href="/Comingsoon"
                        className="footer-pots-comingsoon-button"
                      >
                        <p className="footer-subcategory">
                          Community
                          {"\n"}
                          <button className="footer-coming-soon">
                            Coming soon
                          </button>
                        </p>
                      </a>
                    </div>
                  </div>
                </div> */}
                <div className="footer-category-4">
                  <p className="footer-header-text">LEGAL</p>
                  <div className="footer-subcategories">
                    <div className="footer-subcategory-container">
                      <div className="footer-pots-comingsoon-button">
                        <p className="footer-subcategory">
                          <a
                            href="/Termsandconditions"
                            style={{ color: "white", textDecoration: "none" }}
                          >
                            Terms & Conditions
                          </a>
                          {"\n"}
                          {/* <button className="footer-coming-soon">We are Hiring</button> */}
                        </p>
                      </div>

                      <div className="footer-pots-comingsoon-button">
                        <p className="footer-subcategory">
                          <a
                            className="anchor"
                            href="/Privacypolicy"
                            style={{ color: "white" }}
                          >
                            Privacy Policy
                          </a>
                          {"\n"}
                          {/* <button className="footer-coming-soon">We are Hiring</button> */}
                        </p>
                      </div>

                      <div className="footer-pots-comingsoon-button">
                        <p className="footer-subcategory">
                          <a
                            className="anchor"
                            href="/RefundPolicy"
                            style={{ color: "white" }}
                          >
                            Refund Policy
                          </a>
                          {"\n"}
                          {/* <button className="footer-coming-soon">We are Hiring</button> */}
                        </p>
                      </div>

                      <div className="footer-pots-comingsoon-button">
                        <p className="footer-subcategory">
                          <a
                            href="/Cookiepolicy"
                            style={{ color: "white", textDecoration: "none" }}
                          >
                            Cookie Policy
                          </a>
                          {/* <button className="footer-coming-soon">We are Hiring</button> */}
                        </p>
                      </div>

                      <div className="footer-pots-comingsoon-button">
                        <p className="footer-subcategory">
                          <a
                            href="/GrievancePolicy"
                            style={{ color: "white", textDecoration: "none" }}
                          >
                            Grievance Policy
                          </a>
                          {/* <button className="footer-coming-soon">We are Hiring</button> */}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Column 4: Legal */}
          </div>
          <div className="footer-bottom-card">
            <span
              id="footer-copy"
              className="footer-copyright"
              style={{
                fontSize: "15px",
                fontFamily: "Poppins",
                textAlign: "left",
              }}
            >
              Copyright ©️ 2024 NTAR Bizz Private Limited. All Rights Reserved.
            </span>
            <div className="footer-social d-flex">
              <a
                href="https://www.instagram.com/ntarbusiness/"
                target="blank"
                className="text-white social-media-links "
              >
                <a
                  style={{
                    color: "white",
                    marginLeft: "10px",
                    marginRight: "10px",
                    fontFamily: "Poppins",
                  }}
                >
                  Instagram
                </a>
                <img className="explorearrow" src={sideImage} alt="Girl" />
              </a>

              <a
                href="https://www.facebook.com/ntarbusiness"
                target="blank"
                className="text-white social-media-links "
              >
                <a
                  style={{
                    color: "white",
                    marginLeft: "10px",
                    marginRight: "10px",
                    fontFamily: "Poppins",
                  }}
                >
                  Facebook
                </a>
                <img className="explorearrow" src={sideImage} alt="Girl" />
              </a>
              <a
                href="https://x.com/NtarBusiness"
                target="blank"
                className="text-white social-media-links"
              >
                <a
                  style={{
                    color: "white",
                    marginLeft: "10px",
                    marginRight: "10px",
                    fontFamily: "Poppins",
                  }}
                >
                  Twitter
                </a>
                <img className="explorearrow" src={sideImage} alt="Girl" />
              </a>
              <a
                href="https://www.linkedin.com/company/ntar-for-business"
                target="blank"
                className="text-white social-media-links"
              >
                <a
                  style={{
                    color: "white",
                    marginLeft: "10px",
                    marginRight: "10px",
                    fontFamily: "Poppins",
                  }}
                >
                  LinkedIn
                </a>
                <img className="explorearrow" src={sideImage} alt="Girl" />
              </a>
              <a
                href="https://www.youtube.com/@NTARBusiness"
                target="blank"
                className="text-white social-media-links"
              >
                <a
                  style={{
                    color: "white",
                    marginLeft: "10px",
                    marginRight: "10px",
                    fontFamily: "Poppins",
                  }}
                >
                  YouTube
                </a>
                <img className="explorearrow" src={sideImage} alt="Girl" />
              </a>

              <a
                href="https://in.pinterest.com/NTARBusiness/"
                target="blank"
                className="text-white social-media-links"
              >
                <a
                  style={{
                    color: "white",
                    marginLeft: "10px",
                    marginRight: "10px",
                    fontFamily: "Poppins",
                  }}
                >
                  Pinterest
                </a>
                <img className="explorearrow" src={sideImage} alt="Girl" />
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
